import React, { useEffect, useState } from "react";
import { filter } from "ramda";
import Grid from "@mui/material/Grid";
import { Box, Card } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import Typography from "@mui/material/Typography";
import { useCsps } from "../cspServices";
import { logOut } from "../../auth/authActions";
import { useDispatch } from "react-redux";

const useStyles = makeStyles(theme => ({
  root: {
    width: "100%",
    minHeight: 185,
    padding: theme.spacing(4),
    paddingLeft: theme.spacing(5),
    paddingRight: theme.spacing(5),
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
    borderRadius: 20,
    color: theme.palette.secondary.contrastText,
    display: "flex",
    justifyContent: "flex-start",
    flexDirection: "column",
    [theme.breakpoints.up("md")]: {
      height: "100%",
    },
  },

  count: {
    marginRight: theme.spacing(1),
  },

  h1: {
    fontSize: "6.0rem",
    fontWeight: "bold",
    color: theme.palette.primary.main,
  },

  h4: {
    fontSize: "1.8rem",
    lineHeight: "2.2rem",
    fontWeight: "bold",
    color: theme.palette.primary.main,
  },

  body1: {
    fontSize: "1.4rem",
    textTransform: "uppercase",
  },

  body2: {
    fontSize: "1.4rem",
    lineHeight: "1.8rem",
    fontStyle: "italic",
  },
}));

const CspCard = () => {
  const classes = useStyles();
  const reduxDispatch = useDispatch();
  const results = useCsps();

  const [activeCount, setActiveCount] = useState(0);
  const [totalCount, setTotalCount] = useState(0);

  useEffect(() => {
    if (results.isError) {
      //-- Send user to login if the token has expired or not logged in
      if (results.error.status === 401) {
        reduxDispatch(logOut());
      }
    }

    if (results.isSuccess) {
      setTotalCount(results.data.length);
      setActiveCount(filter(csp => csp.active, results.data).length);
    }
  }, [
    results.isError,
    results.isSuccess,
    results.error,
    results.data,
    reduxDispatch,
  ]);

  return (
    <Card classes={{ root: classes.root }}>
      <Grid container justifyContent="space-between" alignItems="center">
        <Grid item>
          <Typography
            variant="h4"
            component="span"
            classes={{ h4: classes.h4 }}
          >
            CSPs
          </Typography>
        </Grid>
      </Grid>
      {results.isSuccess ? (
        <Box mt={1}>
          <Grid container spacing={1} direction="column">
            <Grid item>
              <Box
                width="100%"
                display="flex"
                alignItems="baseline"
                justifyContent="center"
              >
                <Typography
                  variant="h1"
                  component="span"
                  classes={{ root: classes.count, h1: classes.h1 }}
                >
                  {activeCount.toLocaleString()}
                </Typography>
                <Typography
                  variant="body1"
                  component="span"
                  color="primary"
                  classes={{ body1: classes.body1 }}
                >
                  Active
                </Typography>
              </Box>
            </Grid>

            <Grid item>
              <Box mt={4} display="flex" justifyContent="flex-end">
                <Typography
                  variant="body2"
                  component="div"
                  classes={{ body2: classes.body2 }}
                >
                  {`${totalCount.toLocaleString()} total`}
                </Typography>
              </Box>
            </Grid>
          </Grid>
        </Box>
      ) : (
        <Box>
          <Typography
            variant="h4"
            component="span"
            classes={{ h4: classes.h4 }}
          >
            Loading...
          </Typography>
        </Box>
      )}
    </Card>
  );
};

export default CspCard;
